'use client';
import { Dispatch, SetStateAction } from 'react';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import classes from './styles.module.scss';
import { GreenBill, X } from '../../../../../../public/Images';
import { ChevronRight } from '@mui/icons-material';

import { useRouter } from 'next/navigation';
import Image from 'next/image';
import { possibleBuyUseCarsSources } from '@/types/filter.types';
import { ACTION_CLICK_BUY_CAR } from '@/constants/actions';
import { useAnalytics } from '@/integrations';

const SecoundScreen = ({
    setModal,
}: {
    setModal: Dispatch<SetStateAction<boolean>>;
}) => {
    const { t, i18n } = useTranslation();
    const router = useRouter();
    const { trackEvent } = useAnalytics();

    return (
        <div className={classes.container}>
            <Image
                src={X.src}
                width={X.width}
                height={X.height}
                alt="cloese"
                className={classes.closeIcon}
                onClick={() => setModal(false)}
            />
            <Image
                src={GreenBill.src}
                width={GreenBill.width}
                height={GreenBill.height}
                className={classes.bill}
                alt="Success"
            />
            <Typography variant="h6Medium" className={classes.title}>
                {t('We’ll notify you once the car is available')}
            </Typography>
            <Typography variant="body2" className={classes.subtitle}>
                {t(
                    'Expect recieving SMS for this car when reservation is released'
                )}
            </Typography>
            <button
                className={classes.btn}
                onClick={() => {
                    setModal(false);
                    trackEvent(ACTION_CLICK_BUY_CAR, {
                        source: possibleBuyUseCarsSources.notify_me,
                    });
                    router.push(`/${i18n.language}/buy-used-cars`, {
                        // state: { sourcePage: 'Car Profile' },
                    });
                }}
            >
                <Typography variant={'body1Medium'}>
                    {t('browse all cars')}
                </Typography>
                <ChevronRight
                    className={`${
                        i18n.language === 'ar' && classes.iconReversed
                    }`}
                />
            </button>
        </div>
    );
};

export default SecoundScreen;
